import React, { Component } from 'react'
import {Divider} from "antd";
import { injectIntl } from 'react-intl';

class CreateFolderHeader extends Component {
    constructor(props){
        super(props);
        this.state = {
            bunker: props.bunkerEnabled,
        }
    }
    render() {
        const {
            bunker
        } = this.state;
        const {
            intl
        } = this.props;
        return (
            <div
                style = {{
                    width: "100%",
                    height: 100,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    paddingLeft: "5%",
                    paddingRight: "5%",
                    borderTopLeftRadius: 5,
                    borderTopRightRadius: 5
                }}
            >
                <div
                    style = {{
                        fontFamily: "Roboto",
                        fontWeight: 700,
                        fontSize: 24,
                        color: "#6F6F6F",
                        marginBottom: 10
                    }}
                >
                    {bunker ?  intl.formatMessage({ id: 'upload-folder-create-bunker' }) : intl.formatMessage({ id: 'upload-folder-create-folder' })}
                </div>
                <Divider style={{margin: 0}}/>
            </div>
        );
    }
}
export default injectIntl(CreateFolderHeader);
